import { faUserGear } from "@fortawesome/pro-solid-svg-icons/faUserGear";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconUserGear: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faUserGear} />;
};
